import { render, staticRenderFns } from "./ViewDetailMultiRead.vue?vue&type=template&id=625a80fc&scoped=true&"
import script from "./ViewDetailMultiRead.vue?vue&type=script&lang=js&"
export * from "./ViewDetailMultiRead.vue?vue&type=script&lang=js&"
import style0 from "./ViewDetailMultiRead.vue?vue&type=style&index=0&id=625a80fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625a80fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VImg,VSimpleTable})
